import { render, staticRenderFns } from "./Detailed.vue?vue&type=template&id=cc8c18bc&"
import script from "./Detailed.vue?vue&type=script&lang=ts&"
export * from "./Detailed.vue?vue&type=script&lang=ts&"
import style0 from "./Detailed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports